import { useEffect, useRef, useState } from "react";
import { classnames } from "./helpers/helpers";

export default function Dropdown({ items, select }) {
  const [show, setShow] = useState(false);
  const ref = useRef();
  function onClick(e) {
    e.stopPropagation();
    setShow(true);
  }
  function onClickItem(e, item) {
    e.stopPropagation();
    select(item);
    setShow(false);
  }
  useEffect(() => {
    const listener = (e) => {
      if (!ref.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener("click", listener);
    return () => document.removeEventListener("click", listener);
  }, [ref]);
  return (
    <div className={classnames("dd", { a: show })} ref={ref}>
      <div onClick={onClick}>
        <i className="fa fa-ellipsis-v" />
      </div>
      <div className="dd-l w">
        {items.map((item, i) => {
          return (
            <div key={i} onClick={(e) => onClickItem(e, item)}>
              {item.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
